import { Link } from 'react-router-dom'

const Button = (props) => {
  const {
    text,
    id,
    size,
    onClick,
    link,
    externalLink,
    targetBlank,
    loading,
    active,
    icon,
    type,
    disabled,
    buttonType,
    title,
    extraClass,
    cypress,
    iconRight,
    download,
    isTech,
    biggerIcon,
    ref,
    animationIcon
  } = props

  const renderContent = () => {
    const extra_props = {}

    if (download) {
      extra_props[download] = true
    }

    return (
      <button
        ref={ref}
        type={type && !disabled ? type : 'button'}
        data-cy={`button-${cypress}`}
        className={`relative whitespace-nowrap overflow-hidden ${buttonType} ${size} ${extraClass} ${
          loading ? 'loading' : ''
        } ${active ? ' active' : ''} ${iconRight ? 'flex-row-reverse' : ''} ${
          isTech ? 'tech' : ''
        }`}
        id={id}
        disabled={disabled || loading}
        onClick={!disabled ? onClick : null}
        title={title}
        {...extra_props}
      >
        {icon ? <i className={`${icon} icon-suffix ${biggerIcon ? 'bigger' : ''} ${animationIcon ? 'animate-rotate' : ''}`} /> : null}
        {text ? <span>{text}</span> : null}

        {loading ? (
          <i className='text-xl text-white fa-solid fa-spinner animate-spin absolute w-full h-full flex items-center justify-center loader' />
        ) : null}
      </button>
    )
  }

  if (externalLink) {
    return (
      <a
        href={externalLink}
        target={targetBlank ? '_blank' : ''}
        className={`button-link ${extraClass}`}
        rel='noreferrer'
      >
        {renderContent()}
      </a>
    )
  } else if (link) {
    return (
      <Link to={link} className={`button-link ${extraClass}`}>
        {renderContent()}
      </Link>
    )
  }
  return renderContent()
}

export const PrimaryButton = (props) => (
  <Button {...props} buttonType='primary-button' />
)
export const SecondaryButton = (props) => (
  <Button {...props} buttonType='secondary-button' />
)
export const TertiaryButton = (props) => (
  <Button {...props} buttonType='tertiary-button' />
)
export const ErrorButton = (props) => (
  <Button {...props} buttonType='error-button' />
)
export const DangerButton = (props) => (
  <Button {...props} buttonType='danger-button' />
)

Button.defaultProps = {
  buttonType: 'primary-button',
  disabled: false,
  title: '',
  extraClass: '',
  cypress: '',
  size: 'medium',
}

export default Button
